import React, { useEffect, useState } from "react";
import "./AdminThemeTab.css";

const DEFAULT_COLOR = "#3B82F6";

const initialItems = [
    { id: "text", label: "Input Text", type: "text", placeholder: "Votre texte..." },
    { id: "password", label: "Input Password", type: "password", placeholder: "********" },
    { id: "email", label: "Input Email", type: "email", placeholder: "contact@email.com" },
    { id: "number", label: "Input Number", type: "number", placeholder: "123" },
    { id: "search", label: "Input Search", type: "search", placeholder: "Recherche..." },
    { id: "date", label: "Input Date", type: "date" },
    { id: "time", label: "Input Time", type: "time" },
    { id: "datetime-local", label: "Input Datetime", type: "datetime-local" },
    { id: "month", label: "Input Month", type: "month" },
    { id: "week", label: "Input Week", type: "week" },
    { id: "range", label: "Input Range", type: "range" },
    { id: "checkbox", label: "Checkbox", type: "checkbox" },
    { id: "radio", label: "Radio", type: "radio" },
    { id: "select", label: "Select", type: "select" },
    { id: "textarea", label: "Textarea", type: "textarea" },
    { id: "file", label: "File", type: "file" },
    { id: "button", label: "Button", type: "button" },
    { id: "submit", label: "Submit", type: "submit" },
    { id: "reset", label: "Reset", type: "reset" }
];

export default function AdminThemeTab() {

    const [colors, setColors] = useState(() => {

        const data = {};

        initialItems.forEach(item => {
            data[item.id] = DEFAULT_COLOR;
        });

        return data;
    });
useEffect(() => {

    const saved = localStorage.getItem("themeColors");

    if(saved){

        setColors(JSON.parse(saved));

    }

}, []);

useEffect(() => {

    localStorage.setItem(
        "themeColors",
        JSON.stringify(colors)
    );

}, [colors]);
const generateCss = () => {

    let css = ":root {\n";

    Object.entries(colors).forEach(([key, value]) => {
        css += `    --${key}: ${value};\n`;
    });

    css += "}";

    if (navigator.clipboard && window.isSecureContext) {

        navigator.clipboard.writeText(css)
            .then(() => {
                alert("Variables CSS copiées.");
            })
            .catch(() => {
                fallbackCopy(css);
            });

    } else {

        fallbackCopy(css);

    }
};

const fallbackCopy = (text) => {

    const textarea = document.createElement("textarea");

    textarea.value = text;

    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);

    textarea.select();

    document.execCommand("copy");

    document.body.removeChild(textarea);

    alert("Variables CSS copiées.");
};
    const updateColor = (id, color) => {

        setColors(previous => ({
            ...previous,
            [id]: color
        }));
    };

    const renderInput = (item) => {

        const style = {
            border: `2px solid ${colors[item.id]}`,
            accentColor: colors[item.id]
        };

        switch (item.type) {

            case "text":
            case "password":
            case "email":
            case "number":
            case "search":
            case "date":
            case "time":
            case "datetime-local":
            case "month":
            case "week":
                return (
                    <input
                        type={item.type}
                        placeholder={item.placeholder}
                        style={style}
                    />
                );

            case "range":
                return (
                    <input
                        type="range"
                        style={{
                            accentColor: colors[item.id]
                        }}
                    />
                );

            case "checkbox":
                return (
                    <label className="theme-inline">
                        <input
                            type="checkbox"
                            style={{
                                accentColor: colors[item.id]
                            }}
                        />
                        Checkbox
                    </label>
                );

            case "radio":
                return (
                    <label className="theme-inline">
                        <input
                            type="radio"
                            style={{
                                accentColor: colors[item.id]
                            }}
                        />
                        Radio
                    </label>
                );

            case "select":
                return (
                    <select style={style}>
                        <option>Option 1</option>
                        <option>Option 2</option>
                        <option>Option 3</option>
                    </select>
                );

            case "textarea":
                return (
                    <textarea
                        rows="3"
                        placeholder="Votre texte..."
                        style={style}
                    />
                );

            case "file":
                return (
                    <input
                        type="file"
                        style={style}
                    />
                );

            case "button":
                return (
                    <button
                        type="button"
                        style={{
                            background: colors[item.id],
                            borderColor: colors[item.id]
                        }}
                    >
                        Button
                    </button>
                );

            case "submit":
                return (
                    <button
                        type="submit"
                        style={{
                            background: colors[item.id],
                            borderColor: colors[item.id]
                        }}
                    >
                        Submit
                    </button>
                );

            case "reset":
                return (
                    <button
                        type="reset"
                        style={{
                            background: colors[item.id],
                            borderColor: colors[item.id]
                        }}
                    >
                        Reset
                    </button>
                );

            default:
                return null;
        }
    };

    return (

        <div className="theme-container">

            <div className="theme-header">

                <h2>Gestion du thème</h2>
<button
    className="theme-reset"
    onClick={() => {

        const reset = {};

        initialItems.forEach(item=>{

            reset[item.id] = DEFAULT_COLOR;

        });

        setColors(reset);

    }}
>

Réinitialiser

</button>

<button

className="theme-export"

onClick={()=>{

    const json = JSON.stringify(colors,null,4);

    navigator.clipboard.writeText(json);

    alert("Configuration copiée dans le presse-papiers.");

}}

>

Exporter le thème

</button>

<button

className="theme-export"

onClick={generateCss}

>

Générer le CSS

</button>
                <p>
                    Personnalisez les couleurs de chaque composant HTML.
                </p>

            </div>

            <table className="theme-table">

                <thead>

                    <tr>
                        <th>Composant</th>
                        <th>Aperçu</th>
                        <th>Couleur</th>
                    </tr>

                </thead>

                <tbody>

                    {initialItems.map(item => (

                        <tr key={item.id}>

                            <td>
                                {item.label}
                            </td>

                            <td>

                                <div className="theme-preview">

                                    {renderInput(item)}

                                </div>

                            </td>

                            <td>

                                <div className="theme-color">

                                    <input
                                        type="color"
                                        value={colors[item.id]}
                                        onChange={(e) =>
                                            updateColor(item.id, e.target.value)
                                        }
                                    />

                                    <span>

                                        {colors[item.id]}

                                    </span>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}